import Loadable from 'react-loadable';
import { Login, Page404, Page500 } from '../views/Pages';
import { RouteLoading } from './RouteLoading';
import { RouteProposta } from './RouteProposta';
import { RoutePrePagamento } from './RoutePrePagamento';
// Comentando rota de 'GestaoAcesso' devido sua desativação - USER STORY 37978
// import { RouteGestaoAcessosLegacy } from './RouteGestaoAcessosLegacy';
import { RouteConformidade } from './RouteConformidade';
import { RouteGestaoAcessos } from './RouteGestaoAcessos';
import { RouteUtils } from './RouteUtils';
import { RouteLojas } from './RouteLojas';
import { RouteDashboard } from './RouteDashboard';
import { RoutePosPagamento } from './RoutePosPagamento';
import { RouteServicedesk } from './RouteServicedesk';
import { RoutePosLojas } from './RoutePosLojas';
import { RouteProtocolo } from './RouteProtocolo';

const Dashboard = Loadable({
  loader: () => import('../views/Dashboard'),
  loading: RouteLoading,
});

const RoutesPaginasPai = [
  { path: '/pre-pagamento', exact: true, name: 'Pre-Pagamento' },
  { path: '/conformidade', exact: true, name: 'Conformidade' },
  { path: '/usuarios', exact: true, name: 'Usuários' },
  { path: '/gestao-acessos', exact: true, name: 'Gestão de Acessos' },
  { path: '/lojas', exact: true, name: 'Lojas' },
  { path: '/pre-pagamento', exact: true, name: 'Pre-Pagamento' },
  { path: '/pos-pagamento', exact: true, name: 'Pós-Pagamento' },
  { path: '/servicedesk', exact: true, name: 'Service Desk' }
];

const routes = [
  { path: '/404', exact: true, name: 'Page 404', component: Page404 },
  { path: '/500', exact: true, name: 'Page 500', component: Page500 },
  { path: '/login', exact: true, name: 'Login', component: Login },
  { path: '/pagina-inicial', exact: true, name: '', component: Dashboard },
  ...RoutesPaginasPai,
  ...RouteProposta,
  ...RouteUtils,
  ...RoutePrePagamento,
  ...RouteGestaoAcessos,
  ...RouteConformidade,
  ...RouteLojas,
  ...RoutePosPagamento,
  ...RouteDashboard,
  ...RoutePosPagamento,
  ...RouteServicedesk,
  ...RoutePosLojas,
  ...RouteProtocolo
];

export default routes;
